import React, { useState, useEffect } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { LineChart } from "../../../components/LineChart";
import { x, y } from "../utils/utils";
import { ExpensesCard } from "./ExpensesCard";
import { useSelector } from "react-redux";

export const Analytics = ({
  lineChartData,
  expensesData,
  pageColor: pageColorProp,
}) => {
  const fallbackPageColor = useSelector(
    (state) => state?.switchTab?.brandColor?.brandColor,
  );
  const pageColor = pageColorProp || fallbackPageColor;

  const displayData = lineChartData || {};
  const {
    monthlyAmounts = [],
    weeklyAmounts = [],
    yearlyAmounts = [],
    monthLabels = [],
    weekLabels = [],
    yearLabels = [],
  } = displayData;

  const [plotData, setPlotData] = useState(monthlyAmounts);
  const [interval, setInterval] = useState(monthLabels);
  const [chartLabel, setChartLabel] = useState("Monthly");

  // Re-sync when data arrives after an account switch
  useEffect(() => {
    setPlotData(monthlyAmounts);
    setInterval(monthLabels);
    setChartLabel("Monthly");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lineChartData]);

  return (
    <Flex
      justifyContent="space-between"
      direction={["column", "column", "row"]}
      px={["10px", "10px", "0px"]}
    >
      <Box
        w={["100%", "100%", "58%"]}
        borderRadius={"10px"}
        shadow="md"
        bg="#fff"
        p="20px"
        mb={["10px", "10px", "0px"]}
      >
        <Flex justifyContent="space-between" direction={["column", "row"]}>
          <Text fontSize="22px" fontWeight="bold">
            Report
          </Text>
          <Flex mt={["10px"]} gap={["8px", "8px", "12px"]}>
            {[
              { label: "Weekly", amounts: weeklyAmounts, labels: weekLabels },
              {
                label: "Monthly",
                amounts: monthlyAmounts,
                labels: monthLabels,
              },
              { label: "Yearly", amounts: yearlyAmounts, labels: yearLabels },
            ].map(({ label, amounts, labels }) => (
              <Box
                key={label}
                bg={chartLabel === label ? pageColor : "#fff"}
                color={chartLabel === label ? "#fff" : pageColor}
                border={`1px solid ${pageColor}`}
                borderRadius="5px"
                fontSize="14px"
                fontWeight="medium"
                py="6px"
                w="90px"
                h="35px"
                cursor="pointer"
                textAlign="center"
                onClick={() => {
                  setPlotData(amounts);
                  setInterval(labels);
                  setChartLabel(label);
                }}
              >
                {label}
              </Box>
            ))}
          </Flex>
        </Flex>
        <Box height="260px">
          <LineChart
            plotData={plotData}
            interval={interval}
            chartLabel={chartLabel}
            scaleX={x}
            scaleY={y}
            indicator={pageColor}
          />
        </Box>
      </Box>
      <Box
        w={["100%", "100%", "39%"]}
        bg="#fff"
        borderRadius={"10px"}
        shadow="md"
      >
        <ExpensesCard expensesData={expensesData} pageColor={pageColor} />
      </Box>
    </Flex>
  );
};
